export type PagePermissionLevel = 'none' | 'view' | 'edit';
export type FeaturePermissionLevel = 'none' | 'view' | 'edit_own' | 'edit_all';
export type SecurityLevel = 'guest' | 'user' | 'manager' | 'admin' | 'super_admin';
export type AccessScope = 'self' | 'assigned' | 'site' | 'region' | 'managed' | 'all';

export const SECURITY_LEVELS: SecurityLevel[] = ['guest', 'user', 'manager', 'admin', 'super_admin'];
export const ACCESS_SCOPES: AccessScope[] = ['self', 'assigned', 'site', 'region', 'managed', 'all'];

export const SECURITY_LEVEL_LABELS: Record<SecurityLevel, string> = {
  guest: 'Guest',
  user: 'User',
  manager: 'Manager',
  admin: 'Admin',
  super_admin: 'Super Admin',
};

export const SECURITY_LEVEL_DESCRIPTIONS: Record<SecurityLevel, string> = {
  guest: 'External account. Access comes only from explicit shares or an external workflow role.',
  user: 'Employee authority for their assigned work and sites.',
  manager: 'User authority plus management of assigned teams and managed sites.',
  admin: 'Workspace administration and automatic Full Workspace access.',
  super_admin: 'Protected platform administration, including super-admin-only security controls.',
};

export const SECURITY_LEVEL_RANK: Record<SecurityLevel, number> = {
  guest: 10,
  user: 20,
  manager: 30,
  admin: 40,
  super_admin: 50,
};

export const ACCESS_SCOPE_LABELS: Record<AccessScope, string> = {
  self: 'Self / own',
  assigned: 'Assigned work',
  site: 'Assigned sites',
  region: 'Assigned regions',
  managed: 'Managed teams and sites',
  all: 'All',
};

export const PAGE_PERMISSION_LEVELS: PagePermissionLevel[] = ['none', 'view', 'edit'];
export const FEATURE_PERMISSION_LEVELS: FeaturePermissionLevel[] = ['none', 'view', 'edit_own', 'edit_all'];

export const PAGE_PERMISSION_LABELS: Record<PagePermissionLevel, string> = {
  none: 'No access',
  view: 'View only',
  edit: 'View & edit',
};

export const FEATURE_PERMISSION_LABELS: Record<FeaturePermissionLevel, string> = {
  none: 'No access',
  view: 'View only',
  edit_own: 'Edit own',
  edit_all: 'Edit all',
};
